import { ENV } from "../utils";

export class RiskAssessment {
  baseApi = ENV.BASE_API;

  async getRiskAssessments(accessToken, params = {}) {
    const query = new URLSearchParams();
    if (params.site)        query.set("site",        params.site);
    if (params.sector)      query.set("sector",      params.sector);
    if (params.riskResult)  query.set("riskResult",  params.riskResult);
    if (params.active !== undefined) query.set("active", params.active);
    if (params.company)     query.set("company",     params.company);
    const url = `${this.baseApi}/eval-riesgos?${query.toString()}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getRiskAssessment(accessToken, id) {
    const response = await fetch(`${this.baseApi}/eval-riesgo/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createRiskAssessment(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-eval-riesgo`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateRiskAssessment(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-eval-riesgo/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async copyYear(accessToken, ids, toYear) {
    const response = await fetch(`${this.baseApi}/eval-riesgo/copy-year`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ ids, toYear }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteRiskAssessment(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-eval-riesgo/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
